import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function inr(n, digits = 2) {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  const sign = n < 0 ? "-" : "";
  const abs = Math.abs(n);
  return (
    sign +
    "₹" +
    abs.toLocaleString("en-IN", {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    })
  );
}

export function num(n, digits = 2) {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  return Number(n).toLocaleString("en-IN", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function pct(n, digits = 2) {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  const sign = n > 0 ? "+" : "";
  return sign + Number(n).toFixed(digits) + "%";
}

export function calcLive(trade, livePrice) {
  // Returns { livePL, changePerShare, riskPerShare, riskPct, maxProfit, currentPrice }
  if (livePrice === null || livePrice === undefined) {
    return {};
  }
  const sign = trade.transaction === "BOUGHT" ? 1 : -1;
  const change = livePrice - trade.rate;
  const livePL = sign * change * trade.quantity;
  let riskPerShare = null;
  let riskPct = null;
  if (trade.stop_loss && trade.rate) {
    riskPerShare = Math.abs(trade.rate - trade.stop_loss);
    const invested = trade.rate * trade.quantity;
    if (invested) riskPct = (riskPerShare * trade.quantity) / invested * 100;
  }
  return {
    livePL,
    changePerShare: change,
    changePct: trade.rate ? (change / trade.rate) * 100 * sign : null,
    riskPerShare,
    riskPct,
    currentPrice: livePrice,
  };
}
